import React, { FunctionComponent } from 'react'

import styled from 'styled-components/native'

import { BodyText } from '../../atoms/bodyText/BodyText'
import { BodyTextSize } from '../../styles/typeStyles'
import { ThemeType } from '../../utils/themes/ThemeProvider'

export type DotItem = string | React.ReactNode

const HorizontalRow = styled.View({
  flexDirection: 'row',
  flexWrap: 'wrap',
  alignItems: 'center',
  flexGrow: 1,
  flexShrink: 1,
  flexBasis: 'auto',
})

const Dot = styled.View<{ theme: ThemeType }>(({ theme: { spacing, colors } }) => ({
  width: '2px',
  height: '2px',
  borderRadius: '2px',
  backgroundColor: colors.textPrimary,
  marginHorizontal: spacing['8px'],
  alignSelf: 'center',
}))

export type DotSeparatedRowProps = {
  items: DotItem[]
  textSize?: BodyTextSize
}

/** Renders a horizontal row of items separated by a small dot. */
export const DotSeparatedRow: FunctionComponent<DotSeparatedRowProps> = ({
  items,
  textSize = BodyTextSize.DEFAULT,
}) => {
  return (
    <HorizontalRow>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {typeof item === 'string' ? <BodyText text={item} size={textSize} /> : item}
          {index < items.length - 1 && <Dot />}
        </React.Fragment>
      ))}
    </HorizontalRow>
  )
}
